// Anrede (CR-1, architecture §10.4.3). Created by the WP0 round-2 patch; WP1 owns this file afterwards.
// Only the direct second-person form "Eure Lordschaft"; never the third-person "Seine Lordschaft".
import type { Settings } from './settings.ts';

export type AnredeMode = Settings['address.mode'];

/** Written and spoken form per fixed mode (TTS pronounces STZ "Es-Ti-Si", §13). */
export const ANREDE_FORM = {
  sir: 'Sir', stz: 'STZ', boss: 'Boss', gnaden: 'Euer Gnaden', lord: 'Eure Lordschaft', chris: 'Chris',
} as const satisfies Record<Exclude<AnredeMode, 'mix'>, string>;

/** The forms `mix` rotates through for app-generated greetings and the call firstMessage (CR-1; not "Chris"). */
export const ANREDE_MIX = ['Sir', 'STZ', 'Boss', 'Euer Gnaden', 'Eure Lordschaft'] as const;

export type AnredeForm = (typeof ANREDE_FORM)[keyof typeof ANREDE_FORM];

/** Prompt rule for the Jarvis session context (§10.4.3, CR-1 texts verbatim). */
export function anredeRegel(mode: AnredeMode): string {
  if (mode === 'mix') return 'Sprich Chris abwechselnd mit „Sir“, „STZ“, „Boss“, „Euer Gnaden“ oder „Eure Lordschaft“ an, aber nicht in jedem Satz.';
  return `Sprich Chris mit „${ANREDE_FORM[mode]}“ an, aber nicht in jedem Satz.`;
}

/** The form for app-generated greetings and the call firstMessage (§10.17). `rng` returns [0, 1) like Math.random. */
export function pickAnrede(mode: AnredeMode, rng: () => number = Math.random): AnredeForm {
  if (mode !== 'mix') return ANREDE_FORM[mode];
  const i = Math.min(ANREDE_MIX.length - 1, Math.max(0, Math.floor(rng() * ANREDE_MIX.length)));
  return ANREDE_MIX[i]!;
}
